// Value Distributed Energy Resources
// https://lite.coned.com/_external/cerates/elec_VDER_CRstatement_PSC10.asp
// ./docs/april-2025-rate-update/april-2025-vder.pdf
// Rate IV and V are Standby, the others are Non-Standby per Eugene - https://twist.com/a/9369/ch/691652/t/6861262/c/94905839
export default function getSC9VDERRateElement({
  isHighTension,
  isLocatedInWestchester,
  isOnMarketBasedRate,
}) {
  if (isHighTension) {
    return {
      Standby: [
        {
          rateElementType: 'MonthlyDemand',
          name: 'VDER Capacity Charge',
          billingCategory: 'supply',
          rateComponents: [
            {
              charge: (() => {
                if (isOnMarketBasedRate) {
                  if (isLocatedInWestchester) {
                    return 0.02;
                  }
                  return 0.03;
                }
                return 0.01;
              })(),
              name: 'VDER Capacity Charge',
            },
          ],
        },
        {
          rateElementType: 'MonthlyDemand',
          name: 'VDER Demand Reduction Value (DRV)',
          billingCategory: 'supply',
          rateComponents: [
            {
              charge: 0.05,
              name: 'VDER Demand Reduction Value (DRV)',
            },
          ],
        },
        {
          rateElementType: 'MonthlyDemand',
          name: 'VDER Locational System Relief Value (LSRV)',
          billingCategory: 'supply',
          rateComponents: [
            {
              charge: 0,
              name: 'VDER Locational System Relief Value (LSRV)',
            },
          ],
        },
        {
          rateElementType: 'MonthlyDemand',
          name: 'VDER Community Credit',
          billingCategory: 'supply',
          rateComponents: [
            {
              charge: 0.17,
              name: 'VDER Community Credit',
            },
          ],
        },
      ],
      NonStandby: [
        {
          rateElementType: 'MonthlyDemand',
          name: 'VDER Capacity Charge',
          billingCategory: 'supply',
          rateComponents: [
            {
              charge: (() => {
                if (isOnMarketBasedRate) {
                  if (isLocatedInWestchester) {
                    return 0.02;
                  }
                  return 0.04;
                }
                return 0.02;
              })(),
              name: 'VDER Capacity Charge',
            },
          ],
        },
        {
          rateElementType: 'MonthlyDemand',
          name: 'VDER Demand Reduction Value (DRV)',
          billingCategory: 'supply',
          rateComponents: [
            {
              charge: 0.06,
              name: 'VDER Demand Reduction Value (DRV)',
            },
          ],
        },
        {
          rateElementType: 'MonthlyDemand',
          name: 'VDER Locational System Relief Value (LSRV)',
          billingCategory: 'supply',
          rateComponents: [
            {
              charge: 0.01,
              name: 'VDER Locational System Relief Value (LSRV)',
            },
          ],
        },
        {
          rateElementType: 'MonthlyDemand',
          name: 'VDER Community Credit',
          billingCategory: 'supply',
          rateComponents: [
            {
              charge: 0.23,
              name: 'VDER Community Credit',
            },
          ],
        },
      ],
    };
  }
  return {
    Standby: [
      {
        rateElementType: 'MonthlyDemand',
        name: 'VDER Capacity Charge',
        billingCategory: 'supply',
        rateComponents: [
          {
            charge: (() => {
              if (isOnMarketBasedRate) {
                if (isLocatedInWestchester) {
                  return 0.03;
                }
                return 0.04;
              }
              return 0.02;
            })(),
            name: 'VDER Capacity Charge',
          },
        ],
      },
      {
        rateElementType: 'MonthlyDemand',
        name: 'VDER Demand Reduction Value (DRV)',
        billingCategory: 'supply',
        rateComponents: [
          {
            charge: 0.09,
            name: 'VDER Demand Reduction Value (DRV)',
          },
        ],
      },
      {
        rateElementType: 'MonthlyDemand',
        name: 'VDER Locational System Relief Value (LSRV)',
        billingCategory: 'supply',
        rateComponents: [
          {
            charge: 0.01,
            name: 'VDER Locational System Relief Value (LSRV)',
          },
        ],
      },
      {
        rateElementType: 'MonthlyDemand',
        name: 'VDER Community Credit',
        billingCategory: 'supply',
        rateComponents: [
          {
            charge: 0.27,
            name: 'VDER Community Credit',
          },
        ],
      },
    ],
    NonStandby: [
      {
        rateElementType: 'MonthlyDemand',
        name: 'VDER Capacity Charge',
        billingCategory: 'supply',
        rateComponents: [
          {
            charge: (() => {
              if (isOnMarketBasedRate) {
                if (isLocatedInWestchester) {
                  return 0.04;
                }
                return 0.06;
              }
              return 0.03;
            })(),
            name: 'VDER Capacity Charge',
          },
        ],
      },
      {
        rateElementType: 'MonthlyDemand',
        name: 'VDER Demand Reduction Value (DRV)',
        billingCategory: 'supply',
        rateComponents: [
          {
            charge: 0.11,
            name: 'VDER Demand Reduction Value (DRV)',
          },
        ],
      },
      {
        rateElementType: 'MonthlyDemand',
        name: 'VDER Locational System Relief Value (LSRV)',
        billingCategory: 'supply',
        rateComponents: [
          {
            charge: 0.01,
            name: 'VDER Locational System Relief Value (LSRV)',
          },
        ],
      },
      {
        rateElementType: 'MonthlyDemand',
        name: 'VDER Community Credit',
        billingCategory: 'supply',
        rateComponents: [
          {
            charge: 0.35,
            name: 'VDER Community Credit',
          },
        ],
      },
    ],
  };
}
